import React, { useState } from 'react';
import { Button, Card, Modal, Space, Table, TablePaginationConfig } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined, FormOutlined } from '@ant-design/icons';

import { SuperGroup } from '@services/types';

import CreateSuperGroupModal from './CreateSuperGroupModal';
import styles from './super-grops.module.scss';
import api from '@services/api';
import { toast } from 'react-toastify';

const { Column } = Table;

const SuperGroups = () => {
  const [superGroups, setSuperGroups] = useState<SuperGroup[]>([]);
  const [addSuperGroupModalVisibility, setAddSuperGroupModalVisibility] = useState(false);
  const [superGroupToUpdate, setSuperGroupToUpdate] = useState<SuperGroup>();
  const [pagination, setPagination] = React.useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    total: superGroups.length,
  });

  React.useEffect(() => {
    api.administration.getSuperGroups().then((groups) => {
      setSuperGroups(groups);
      setPagination({
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        total: groups.length || 0,
      });
    });
  }, []);

  const handleTableChange = React.useCallback((newPagination: TablePaginationConfig) => {
    setPagination(newPagination);
  }, []);

  const showDeleteConfirm = (superGroup: SuperGroup) => {
    Modal.confirm({
      title: 'Are you sure delete this scope?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await api.administration.deleteSuperGroup(superGroup.id);
          setSuperGroups(superGroups.filter(({ id }) => id !== superGroup.id));
          toast.success('Scope was deleted successfully');
        } catch (error) {
          console.log('Scope was not deleted ~ error', error);
          toast.error('Scope was not deleted');
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  return (
    <Card
      title="Scopes"
      extra={
        <Button type="primary" onClick={() => setAddSuperGroupModalVisibility(true)}>
          Add
        </Button>
      }
      bodyStyle={{ padding: 0 }}
    >
      <Table
        dataSource={superGroups}
        pagination={pagination}
        onChange={handleTableChange}
        rowKey={(record: SuperGroup) => record.id}
        rowClassName={styles.row}
      >
        <Column title="Name" dataIndex="name" key="name" />
        <Column
          title="Actions"
          key="action"
          render={(text, superGroup: SuperGroup) => (
            <Space size="middle">
              <FormOutlined onClick={() => setSuperGroupToUpdate(superGroup)} />
              <DeleteOutlined onClick={() => showDeleteConfirm(superGroup)} />
            </Space>
          )}
        />
      </Table>
      <CreateSuperGroupModal
        setSuperGroups={setSuperGroups}
        visible={addSuperGroupModalVisibility}
        onClose={() => {
          setAddSuperGroupModalVisibility(false);
        }}
      />
      {superGroupToUpdate && (
        <CreateSuperGroupModal
          setSuperGroups={setSuperGroups}
          superGroupToUpdate={superGroupToUpdate}
          setSuperGroupToUpdate={setSuperGroupToUpdate}
          visible={!!superGroupToUpdate}
          onClose={() => {
            setSuperGroupToUpdate(undefined);
          }}
        />
      )}
    </Card>
  );
};

export default React.memo(SuperGroups);
